import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useController } from 'react-hook-form';
import { Asterisk, Inner, InputField, Label, Message, Outer } from './input.styles';
export default function Input({ children, name, label, control, rules, shouldUnregister, type, isRequired, ...inputProps }) {
    const { field, fieldState: { error }, } = useController({
        name,
        control,
        rules,
        shouldUnregister,
    });
    return (_jsxs(Outer, { children: [_jsxs(Inner, { type: type, children: [label && _jsxs(Label, { htmlFor: label, children: [children ?? label, isRequired && _jsx(Asterisk, { children: "*" })] }), _jsx(InputField, { ...inputProps, "data-testid": field.name, type: type, defaultValue: field.value ?? undefined, onBlur: field.onBlur, onChange: field.onChange, isError: !!error, ref: field.ref })] }), !!error && _jsx(Message, { children: error.message })] }));
}
